<script setup lang="ts">
import { addProtocol, Map, type MapOptions, removeProtocol } from "maplibre-gl";
import { Protocol } from "pmtiles";
import { onMounted, onUnmounted, useTemplateRef } from "vue";

export type BaseMapOptions = Omit<MapOptions, "container">;

const { initialOptions } = defineProps<{
  initialOptions?: BaseMapOptions;
}>();

const emit = defineEmits<{
  loaded: [map: Map];
}>();

const $map = useTemplateRef("$map");

onMounted(() => {
  if (!$map.value) {
    return;
  }

  const protocol = new Protocol();

  addProtocol("pmtiles", protocol.tile);

  const map = new Map({
    ...initialOptions,
    container: $map.value,
  });

  map.on("load", () => emit("loaded", map));
});

onUnmounted(() => {
  removeProtocol("pmtiles");
});
</script>

<template>
  <div ref="$map"></div>
</template>

<style lang="scss">
@import "maplibre-gl/dist/maplibre-gl.css";
</style>
